import Big from 'big.js';
import { ProjectedCostChartData } from '@/src/components/Chart/ProjectedCostChart/ProjectedCostChart';
import { getPoundValue } from '@/src/utils/money';
import format from 'date-fns/format';
import { ProjectedCostsResponse } from '@/src/types/Response';

export const mapToChartData = (
  projectedCosts: ProjectedCostsResponse,
): Array<ProjectedCostChartData> => {
  const { electricity, gas, boltOns } = projectedCosts;

  if (!electricity && !gas && !boltOns) {
    return [];
  }

  const dataPoints = (electricity || gas || boltOns)!.length;

  return [...Array(dataPoints)].reduce((result, _, currentIndex) => {
    const projectedElec = electricity && electricity[currentIndex];
    const projectedGas = gas && gas[currentIndex];
    const projectedBoltOns = boltOns && boltOns[currentIndex];

    const electricityCost =
      projectedElec && Big(getPoundValue(projectedElec.cost));
    const gasCost = projectedGas && Big(getPoundValue(projectedGas.cost));
    const boltOnCost =
      projectedBoltOns && Big(getPoundValue(projectedBoltOns.cost));

    if (
      (electricityCost && electricityCost.gt(0)) ||
      (gasCost && gasCost.gt(0)) ||
      (boltOnCost && boltOnCost.gt(0))
    ) {
      result.push({
        electricityCost,
        gasCost,
        boltOnCost,
        date: format(
          (projectedElec || projectedGas || projectedBoltOns)!.date,
          'MMMM YYYY',
        ),
        month: format(
          (projectedElec || projectedGas || projectedBoltOns)!.date,
          'MMM',
        ),
        days: Math.max(
          (projectedElec || { days: 0 }).days,
          (projectedGas || { days: 0 }).days,
          (projectedBoltOns || { days: 0 }).days,
        ),
      });
    }
    return result;
  }, []);
};
